import { MenuItem } from './menu.model';

/**
 * Add roles attribute to limit access
 * the roles in roles attribute are allowed to access menu item
 * when no roles attribute is present, all roles are allowed to access menu item
 */
export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'Dashboard',
    link: '/pages/dashboard',
    icon: 'assets/images/icons/dashboard.png',
    roles: [1, 2, 3, 4, 6, 7]
  },
  {
    id: 2,
    label: 'Leads',
    icon: 'assets/images/icons/third-party.png',
    isUiElement: true,
    roles: [1, 2, 3, 4, 6, 7],
    subItems: [
      {
        id: 21,
        label: 'Leads Customers',
        link: '/third-party/leads',
        parentId: 2,
        roles: [1, 3, 4, 7]
      },
      {
        id: 22,
        label: 'Leads Suppliers',
        link: '/third-party/lead-suppliers',
        parentId: 2,
        roles: [1, 2, 4,6]
      },
    ]
  },
  {
    id: 3,
    label: 'Clients',
    icon: 'assets/images/icons/third-party.png',
    isUiElement: true,
    roles: [1, 2, 3, 4, 6, 7],
    subItems: [
      {
        id: 31,
        label: 'Costumers',
        link: '/third-party/customers',
        parentId: 3,
        roles: [1, 3, 4, 7]
      },
      {
        id: 32,
        label: 'Suppliers',
        link: '/third-party/suppliers',
        parentId: 3,
        roles: [1, 2, 4, 6]
      },
    ]
  },
  {
    id: 4,
    label: 'Team BBG',
    icon: 'assets/images/icons/sales.png',
    roles: [1, 5, 6, 7],
    subItems: [
      {
        id: 41,
        label: 'Prchase',
        link: '/sales/purchase',
        parentId: 4
      },
      {
        id: 42,
        label: 'Export',
        link: '/sales/export',
        parentId: 4
      },
      {
        id: 43,
        label: 'Marketing',
        link: '/marketing/list',
        parentId: 4,
        icon: 'assets/images/icons/sales.png',
        roles: [1]
      },
      {
        id: 44,
        label: 'Managers',
        link: '/managers/list',
        parentId: 4,
        roles: [1]
      },
      {
        id: 44,
        label: 'Support',
        link: '/support/list',
        parentId: 4,
        roles: [1]
      }
    ]
  },
  {
    id: 5,
    label: 'Catalog',
    icon: 'assets/images/icons/catalog.png',
    roles: [1, 2, 3, 4, 6, 7],
    subItems: [
      {
        id: 51,
        label: 'Catalog',
        link: '/catalogue/list',
        parentId: 5
      },
      {
        id: 52,
        label: 'Flash Offers',
        link: '/offers/list',
        parentId: 5
      },
      {
        id: 54,
        label: 'Catalog Generator',
        link: '/catalog-generator/generate',
        parentId: 5
      },
      {
        id: 55,
        label: 'Catalog Templates',
        link: '/catalog-generator/templates',
        parentId: 5
      }
    ]
  },
  // {
  //   id: 6,
  //   label: 'Mailing',
  //   icon: 'assets/images/icons/mailing.png',
  //   roles: [1, 4],
  //   subItems: [
  //     {
  //       id: 61,
  //       label: 'Templates',
  //       link: '/mails/templates',
  //       parentId: 6
  //     },
  //     {
  //       id: 62,
  //       label: 'Email',
  //       link: '/mails',
  //       parentId: 6
  //     },
  //     {
  //       id: 63,
  //       label: 'Whatsapp',
  //       link: '/whatsapp/templates',
  //       parentId: 6
  //     },
  //   ]
  // },
  {
    id: 53,
    icon: 'assets/images/icons/products-icon.png',
    label: 'Products',
    link: '/products/product-file-manager',
    roles: [1, 2, 3, 6, 7],
  },
  {
    id: 6,
    label: 'Quotes',
    icon: 'assets/images/icons/products-icon.png',
    roles: [1, 2, 3, 5, 6, 7],
    subItems:[
      {
        id:110,
        label: 'Unvalidated Quotes',
        link: '/orders/list-orders',
        queryParams: { externalOrderId: 'null', status: 'requested' },
      },
      {
        id:9,
        label: 'Validated Quotes',
        link: '/orders/list-orders',
        queryParams: {externalOrderId: 'null', status: 'validated'}
      },
    ]
  },
  {
    id: 7,
    label: 'Orders',
    icon: 'assets/images/icons/orders.png',
    roles: [1, 2, 3, 5, 6, 7, 8],
    link: '/orders/list-orders',
    queryParams: { externalOrderId: 'not_null' },
  },
  {
    id: 8,
    label: 'Config',
    icon: 'assets/images/icons/cog.png',
    roles: [1],
    subItems: [
      {
        id: 81,
        label: "Clients Document Types",
        link: '/third-party/document-types',
        parentId: 2,
      },
      {
        id: 82,
        label: 'Complaints',
        link: '/third-party/complaints',
        parentId: 2,
      },
      {
        id: 83,
        label: "Orders Document Types",
        link: '/orders/document-types',
        parentId: 7,
      },
      {
        id: 84,
        label: 'Tags',
        link: '/tags/list-tags',
      },
    ]
  },
  {
    id: 8,
    label: 'Tags',
    link: '/tags/list-tags',
    icon: 'assets/images/icons/mailing.png',
    roles: [2, 3, 4, 6, 7]
  },
];

